var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOAuthPathFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1494,
    height: 115,
    viewBox: "0 0 1494 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    d: "M0,0H1494a0,0,0,0,1,0,0V99a16,16,0,0,1-16,16H16A16,16,0,0,1,0,99V0A0,0,0,0,1,0,0Z",
    transform: "translate(271 539)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_689",
    "data-name": "Mask Group 689",
    transform: "translate(-271 -539)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_15",
    "data-name": "Union 15",
    d: "M0,75.475V37.08H1494V98.859s-204.015-77.55-749.982-23.384C562.007,93.533,418.7,99.55,308.474,99.549,88.055,99.546,0,75.475,0,75.475ZM0,37.08V0H1492.6V37.08Z",
    transform: "translate(1764.999 654) rotate(180)",
    fill: "#62143a",
    opacity: 0.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOAuthPathFooter);
export default __webpack_public_path__ + "static/media/o-auth-path-footer.0f6d67b8fe1899a39ebcfffaee814c20.svg";
export { ForwardRef as ReactComponent };